import { AdmService } from 'src/app/shared/services/adm.service';
import { Component, Inject, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IdentityRole } from 'src/app/shared/models/identityRole';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/shared/models/usuario';
import { PVService } from '../../services/pv.service';
import { isMobile, isMobileXL } from '../../utils/helpers';

@Component({
  selector: 'app-nrooc-dialog',
  templateUrl: './nrooc-dialog.component.html'
})
export class NroOCDialogComponent {

  required: boolean = false;
  form: FormGroup;

  constructor(
    private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<NroOCDialogComponent>,
    private fb: FormBuilder,
    private router: Router,
    private pvService: PVService,


    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    // if (data.required != null) {
    //   this.required = data.required;
    // }

    this.form = this.fb.group({
      nroOC: [''],

    })
  }

  public Etiquetas: {

    NroOC: string,
  }


  public Validaciones: {

    NroOC: string,
  }

  ngOnInit() {
   // this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close());
    this.Etiquetas = {
      NroOC: this.configService.etiquetas.NroOC
    }
    this.Validaciones = {
      NroOC: this.configService.validaciones.NroOC
    }
    // if (this.required) {
    //   this.form.controls['nroOC'].setValidators([Validators.required]); 
    //   this.form.controls['nroOC'].updateValueAndValidity();
    // }
  }

  aceptar() {
    this.dialogRef.close(this.form.controls['nroOC'].value);
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

}
